import CarDemo1Container from "../../components/home/carDemo1";

const CarDemo1 = () => {
  return <CarDemo1Container />;
};

export default CarDemo1;
